


import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { X } from "lucide-react";
import axios from "axios";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";

function AddGreetingCard() {
  const [searchParams] = useSearchParams();
  const greetingId = searchParams.get("id");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedSubCategories, setSelectedSubCategories] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState({});
  const [logo, setLogo] = useState(null);
  const [price, setPrice] = useState("");
  const [uploadedLogoUrl, setUploadedLogoUrl] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [titleError, setTitleError] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [subCategoryError, setSubCategoryError] = useState("");
  const [logoError, setLogoError] = useState("");
  const [isFormProcessing, setIsFormProcessing] = useState(false);
  const [cartType, setCartType] = useState("");
  const [overview, setOverview] = useState("");
  const [cartTypeError, setCartTypeError] = useState("");
  const [overviewError, setOverviewError] = useState("");
  const [categoryData, setCategoryData] = useState([]);

  const navigate = useNavigate();

  const categoryDataValues = () => {
    axios
      .get(`${process.env.REACT_APP_APIURL}category/list?front_category=true`)
      .then((res) => {
        if (res.data.status === "success") {
          const data = res.data.result.map((item) => item.category);
          setCategoryData(data);
        } else {
          console.log("Failed to fetch data.");
        }
      })
      .catch((error) => {
        console.error("Error fetching category data:", error);
      });
  };

  useEffect(() => {
    categoryDataValues();
  }, []);

  useEffect(() => {
    if (greetingId) {
      fetchGreetingData(greetingId);
    }
  }, [greetingId]);

  const fetchGreetingData = (id) => {
    axios
      .get(`${process.env.REACT_APP_APIURL}greeting/list`, {
        params: {
          greeting_id: id,
          admin: true
        },
      })
      .then((res) => {
        if (res.data.status === "success") {
          const greeting = res.data.result;
          setTitle(greeting.name);
          setDescription(greeting.description);
          setUploadedLogoUrl(greeting.url);
          setPrice(greeting.price);
          setCartType(greeting.cart_type);
          setOverview(greeting.orientation);

          setSelectedSubCategories(greeting.category_id);
          if (Array.isArray(greeting.category_id)) {
            // Extract unique parent categories
            const categories = [...new Set(greeting.category_id.map(cat =>
              cat.category || cat.parentCategory
            ))];
            setSelectedCategories(categories);

            // Set subcategories
            setSelectedSubCategories(greeting.category_id.map(cat => ({
              id: cat._id || cat.id,
              subcategory: cat.subcategory || cat.name,
              parentCategory: cat.category || cat.parentCategory,
              _id: cat._id
            })));

            // Fetch subcategories for each category
            categories.forEach(category => {
              fetchSubCategories(category);
            });
          }
        }
      })
      .catch((err) => {
        console.error("Error fetching greeting data:", err);
        setErrorMessage("Failed to fetch greeting data");
      });
  };

  const handleCategorySelect = (category) => {
    if (!selectedCategories.includes(category)) {
      const updatedCategories = [...selectedCategories, category];
      setSelectedCategories(updatedCategories);
      fetchSubCategories(category);
    }
  };

  const handleRemoveCategory = (categoryToRemove) => {
    setSelectedCategories(selectedCategories.filter(cat => cat !== categoryToRemove));
    // Remove all subcategories belonging to this category
    setSelectedSubCategories(selectedSubCategories.filter(subCat =>
      subCat.parentCategory !== categoryToRemove
    ));
  };
  const fetchSubCategories = (category) => {
    const apiUrl = `${process.env.REACT_APP_APIURL}category/list?category=${category}`;
    axios
      .get(apiUrl)
      .then((res) => {
        const data = res.data.result.map((item) => ({
          id: item._id,
          subcategory: item.subcategory,
          parentCategory: category  // Add parent category reference
        }));
        setSubCategoryData(prev => ({
          ...prev,
          [category]: data
        }));
      })
      .catch((err) => {
        console.error("Error fetching subcategories:", err);
      });
  };
  // Update handleSubCategorySelect to match Product page logic
  const handleSubCategorySelect = (subcategory) => {
    if (!selectedSubCategories.find(sc => sc.id === subcategory.id)) {
      setSelectedSubCategories([...selectedSubCategories, subcategory]);
    }
  };

  const handleRemoveSubCategory = (subcategoryId) => {
    setSelectedSubCategories(selectedSubCategories.filter(sc =>
      sc.id !== subcategoryId && sc._id !== subcategoryId
    ));
  };

  const handleAddGreetingCard = async (e) => {
    e.preventDefault();
    setIsFormProcessing(true);

    let valid = true;

    if (title.trim() === "") {
      setTitleError("Title is required");
      valid = false;
    }

    // if (selectedCategories.length === 0) {
    //   setCategoryError("At least one category is required");
    //   valid = false;
    // }

    if (selectedSubCategories.length === 0) {
      setSubCategoryError("At least one subcategory is required");
      valid = false;
    }

    if (!logo && !uploadedLogoUrl) {
      setLogoError("Image is required");
      valid = false;
    }

    if (cartType.trim() === "") {
      setCartTypeError("Card Type is required");
      valid = false;
    }

    if (overview.trim() === "") {
      setOverviewError("Orientation is required");
      valid = false;
    }

    if (!valid) {
      setIsFormProcessing(false);
      return;
    }

    try {
      let logoUrl = uploadedLogoUrl;
      if (logo) {
        logoUrl = await fileUpload();
      }

      const apiUrl = greetingId
        ? `${process.env.REACT_APP_APIURL}greeting/update`
        : `${process.env.REACT_APP_APIURL}greeting/create`;

      const payload = {
        name: title,
        description: description,
        url: logoUrl,
        price: price,
        greeting_id: greetingId || "",
        cart_type: cartType,
        orientation: overview,
        categories: selectedCategories,
        // edit option
        // selectedSubCategories._id   existing id with new id

        // category_id: selectedSubCategories //new id
        // .map(subCat => subCat.id)
        // .filter(Boolean)
        // .filter(id => id.trim() !== '')
        // .join(','),
        category_id: selectedSubCategories
          .flatMap(subCat => [subCat._id, subCat.id]) // Use _id (existing) and id (new)
          .filter(Boolean) // Remove null/undefined values
          .filter(id => id.trim() !== '') // Ensure no empty strings
          .join(','), // Convert to a comma-separated string


        subcategories: selectedSubCategories
      };
      const businessId = localStorage.getItem("business_id");
      const signupStatus = localStorage.getItem("signup");
      if (businessId && signupStatus === "user") {
        payload.business_id = businessId; 
      }
      const response = await axios.post(apiUrl, payload);

      if (response.data.status === "success") {
        setSuccessMessage(greetingId ? "Greeting Card updated successfully!" : "Greeting Card added successfully!");
        setTimeout(() => {
          navigate("/greetingcard");
        }, 2000);
      } else {
        setErrorMessage("Failed to add/update greeting");
      }
    } catch (err) {
      console.error("Error:", err);
      setErrorMessage("Failed to process request");
    } finally {
      setIsFormProcessing(false);
    }
  };

  const fileUpload = () => {
    const formData = new FormData();
    formData.append("file", logo);

    return axios
      .post(`${process.env.REACT_APP_APIURL}file/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.data.status === "success") {
          setUploadedLogoUrl(res.data.result.files[0].file_url);
          return res.data.result.files[0].file_url;
        } else {
          throw new Error("File upload failed");
        }
      });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = function (event) {
      const img = new Image();
      img.src = event.target.result;

      img.onload = function () {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const maxWidth = 800;
        const maxHeight = 600;

        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);

        const resizedDataURL = canvas.toDataURL("image/jpeg");
        const blob = dataURItoBlob(resizedDataURL, file.name);
        setLogo(blob);
      };
    };

    reader.readAsDataURL(file);
  };

  const dataURItoBlob = (dataURI, filename) => {
    const byteString = atob(dataURI.split(",")[1]);
    const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new File([ab], filename, { type: mimeString });
  };


  console.log("------------------------------")
  console.log(selectedSubCategories)



  return (
    <div className="wrapper">
      <header>
        <NavigationBar />
      </header>

      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0 txt_lft">
                  {greetingId ? "Edit Greeting Card" : "Add Greeting Card"}
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="frmwdth_cntr">
                <div className="col-lg-12">
                  <div className="card card-primary card-outline">
                    <form className="form-horizontal" onSubmit={handleAddGreetingCard}>
                      <div className="card-body">
                        {/* Title Field */}
                        <div className="form-group row">
                          <label className="col-12 col-md-4 col-form-label">
                            Title<span className="text-danger">*</span>
                          </label>
                          <div className="col-12 col-md-8">
                            <input
                              type="text"
                              className="form-control"
                              value={title}
                              onChange={(e) => setTitle(e.target.value)}
                            />
                            {titleError && <small className="text-danger">{titleError}</small>}
                          </div>
                        </div>

                        {/* Categories Selection */}
                        <div className="form-group row">
                          <label className="col-12 col-md-4 col-form-label">
                            Categories<span className="text-danger">*</span>
                          </label>
                          <div className="col-12 col-md-8">
                            <select
                              className="form-control mb-2"
                              onChange={(e) => handleCategorySelect(e.target.value)}
                              value=""
                            >
                              <option value="">Select categories</option>
                              {categoryData
                                .filter(cat => !selectedCategories.includes(cat))
                                .map((category, index) => (
                                  <option key={index} value={category}>
                                    {category}
                                  </option>
                                ))
                              }
                            </select>

                            {/* Selected Categories Display */}
                            <div className="selected-items mt-2">
                              {selectedCategories.map((category, index) => (
                                <div key={index} className="badge bg-primary p-2 m-1">
                                  {category}
                                  <button
                                    type="button"
                                    className="btn btn-link text-white p-0 ml-2"
                                    onClick={() => handleRemoveCategory(category)}
                                  >
                                    <X size={14} />
                                  </button>
                                </div>
                              ))}
                            </div>
                            {categoryError && <small className="text-danger">{categoryError}</small>}
                          </div>
                        </div>

                        {/* SubCategories Selection */}
                        <div className="form-group row">
                          <label className="col-12 col-md-4 col-form-label">
                            SubCategories<span className="text-danger">*</span>
                          </label>
                          <div className="col-12 col-md-8">
                            {selectedCategories.map((category, index) => (
                              <div key={index} className="mb-2">
                                <label className="text-muted mb-1">{category}</label>
                                <select
                                  className="form-control"
                                  onChange={(e) => {
                                    const selected = subCategoryData[category]?.find(
                                      sc => sc.id === e.target.value
                                    );
                                    if (selected) {
                                      handleSubCategorySelect({
                                        ...selected,
                                        parentCategory: category
                                      });
                                    }
                                  }}
                                  value=""
                                >
                                  <option value="">Select subcategories for {category}</option>
                                  {subCategoryData[category]?.map((subCat, idx) => (
                                    <option key={idx} value={subCat.id}>
                                      {subCat.subcategory}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            ))}

                            {/* Selected Subcategories Display */}
                            <div className="selected-items mt-2">
                              {selectedSubCategories.map((subCategory) => (
                                <div key={subCategory.id || subCategory._id} className="badge bg-info p-2 m-1">
                                  {subCategory.subcategory}
                                  <button
                                    type="button"
                                    className="btn btn-link text-white p-0 ml-2"
                                    onClick={() => handleRemoveSubCategory(subCategory.id || subCategory._id)}
                                  >
                                    <X size={14} />
                                  </button>
                                </div>
                              ))}
                            </div>
                            {subCategoryError && <small className="text-danger">{subCategoryError}</small>}
                          </div>
                        </div>


                        {/* Image Field */}
                        <div className="form-group row">
                          <label className="col-12 col-md-4 col-form-label">
                            Image<span className="f_red">*</span>
                          </label>
                          <div className="col-12 col-md-8">
                            <div className="position-relative">
                              <label className="btn-bs-file btn btn-primary">
                                Browse
                                <input type="file" onChange={handleFileChange} />
                              </label>
                            </div>
                            {logo || uploadedLogoUrl ? (
                              <div className="product_imgdiv mt-3">
                                <img src={uploadedLogoUrl || URL.createObjectURL(logo)} alt="Greeting Card Logo" />
                                <div className="product_imgdel">
                                  <i className="fa-solid fa-xmark" onClick={() => {
                                      setLogo(null);
                                      setUploadedLogoUrl("");
                                    }} />
                                </div>
                              </div>
                            ) : (
                              <small className="text-danger">{logoError}</small>
                            )}
                          </div>
                        </div>

                        <div className="form-group row">
                          <label className="col-12 col-md-4 col-form-label">
                            Card Type<span className="f_red">*</span>
                          </label>
                          <div className="col-12 col-md-8">
                            <select
                              className="form-control"
                              value={cartType}
                              onChange={(e) => setCartType(e.target.value)}
                            >
                              <option value="" disabled>
                                Select a Cart Type
                              </option>
                              <option value="Flat" >
                                Flat
                              </option>
                              <option value="Folded" >
                                Folded
                              </option>
                            </select>
                            {cartTypeError && <small className="text-danger">{cartTypeError}</small>}
                          </div>
                        </div>

                        <div className="form-group row">
                          <label className="col-12 col-md-4 col-form-label">
                            Orientation<span className="f_red">*</span>
                          </label>
                          <div className="col-12 col-md-8">
                            <select
                              className="form-control"
                              value={overview}
                              onChange={(e) => setOverview(e.target.value)}
                            >
                              <option value="" disabled>
                                Select a Orientation
                              </option>
                              <option value="Portrait" >
                                Portrait
                              </option>
                              <option value="Landscape" >
                                Landscape
                              </option>
                              <option value="Square" >
                                Square
                              </option>
                            </select>
                            {overviewError && <small className="text-danger">{overviewError}</small>}
                          </div>
                        </div>

                        {/* Price Field */}
                        <div className="form-group row">
                          <label className="col-12 col-md-4 col-form-label">
                            Price ₹<span className="f_red">*</span>
                          </label>
                          <div className="col-12 col-md-8">
                            <input
                              type="text"
                              className="form-control"
                              value={price}
                              onChange={(e) => setPrice(e.target.value)}
                            />
                          </div>
                        </div>

                        {/* Error Message */}
                        {errorMessage && <div className="text-danger">{errorMessage}</div>}

                        {/* Success Message */}
                        {successMessage && <div className="text-success">{successMessage}</div>}
                      </div>

                      {/* Form Submit Button */}
                      <div className="card-footer text-center">
                        <button type="submit" className="btn btn-primary" disabled={isFormProcessing}>
                          {greetingId ? "Update" : "Add"}
                        </button>
                      </div>
                    </form>
                    {/* /.form end */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default AddGreetingCard;